"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "CommandPaletteService", {
    enumerable: true,
    get: function() {
        return CommandPaletteService;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _commandPaletteHelpers = require("src/helpers/commandPaletteHelpers");
const _serialize = require("~/utils/serialize");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
let CommandPaletteService = class CommandPaletteService {
    async commandPalette(param) {
        const cmdData = [];
        try {
            var _param_user;
            const list = await (0, _commandPaletteHelpers.getCommandPaletteForUserWorkspace)((_param_user = param.user) == null ? void 0 : _param_user.id);
            const bases = new Map();
            const tables = new Map();
            const views = new Map();
            for (const item of list){
                if (!bases.has(item.base_id)) {
                    bases.set(item.base_id, {
                        id: item.base_id,
                        title: item.base_title,
                        meta: (0, _serialize.deserializeJSON)(item.base_meta)
                    });
                }
                if (!tables.has(item.table_id)) {
                    tables.set(item.table_id, {
                        id: item.table_id,
                        title: item.table_title,
                        meta: (0, _serialize.deserializeJSON)(item.table_meta),
                        base_id: item.base_id,
                        type: item.table_type,
                        synced: item.table_synced
                    });
                }
                if (!views.has(item.view_id)) {
                    views.set(item.view_id, {
                        id: item.view_id,
                        title: item.view_title,
                        meta: (0, _serialize.deserializeJSON)(item.view_meta),
                        base_id: item.base_id,
                        table_id: item.table_id,
                        type: item.view_type
                    });
                }
            }
            for (const [id, base] of bases){
                var _deserializeJSON;
                cmdData.push({
                    id: `p-${id}`,
                    title: base.title,
                    icon: 'project',
                    iconColor: (_deserializeJSON = (0, _serialize.deserializeJSON)(base.meta)) == null ? void 0 : _deserializeJSON.iconColor,
                    section: 'Bases'
                });
            }
            for (const [id, table] of tables){
                var _table_meta, _bases_get;
                cmdData.push({
                    id: `tbl-${id}`,
                    title: table.title,
                    parent: `p-${table.base_id}`,
                    icon: (table == null ? void 0 : (_table_meta = table.meta) == null ? void 0 : _table_meta.icon) || table.type,
                    projectName: (_bases_get = bases.get(table.base_id)) == null ? void 0 : _bases_get.title,
                    section: 'Tables',
                    synced: table == null ? void 0 : table.synced
                });
            }
            for (const [id, view] of views){
                var _view_meta, _bases_get1;
                cmdData.push({
                    id: `vw-${id}`,
                    title: `${view.title}`,
                    parent: `tbl-${view.table_id}`,
                    icon: (view == null ? void 0 : (_view_meta = view.meta) == null ? void 0 : _view_meta.icon) || _nocodbsdk.viewTypeAlias[view.type] || 'table',
                    projectName: (_bases_get1 = bases.get(view.base_id)) == null ? void 0 : _bases_get1.title,
                    section: 'Views',
                    handler: {
                        type: 'navigate',
                        payload: `/nc/${view.base_id}/${view.table_id}/${encodeURIComponent(id)}`
                    }
                });
            }
        } catch (e) {
            this.logger.warn(e);
            return [];
        }
        return cmdData;
    }
    constructor(){
        this.logger = new _common.Logger('CommandPaletteService');
    }
};
CommandPaletteService = _ts_decorate([
    (0, _common.Injectable)()
], CommandPaletteService);
